import { nextTick, onMounted, getCurrentInstance } from 'vue';

/**
 * Forces non-silent validation on mount when the component's value fails validation rules.
 *
 * When a component is (re)mounted by AG-Grid, Vuetify's onMounted calls validate(silent=true)
 * which sets isPristine=true, hiding any existing validation errors. This composable
 * counters that by running a non-silent validate in the next tick when errors are detected.
 *
 * @param {Object} options
 * @param {string} options.refName - The template ref name of the Vuetify input component.
 */
export default function useForceValidateOnMount({ refName }) {
    const instance = getCurrentInstance();

    onMounted(() => {
        const vm = instance?.proxy;
        if (!vm) return;

        const { forceValidateOnMount, rules, model } = vm;
        if (!forceValidateOnMount || !rules || !rules.length) return;

        const hasError = rules.some(rule => rule(model) !== true);
        if (hasError) {
            nextTick(() => {
                vm.$refs[refName]?.validate();
            });
        }
    });
}
